import React, { useState } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import CarrosselCard from './carrossel-card';

const SortableCarrosselCard = (props) => {
	const [wasDragging, setWasDragging] = useState(false);

	const {
		attributes,
		listeners,
		setNodeRef,
		transform,
		transition,
		isDragging,
		isSorting,
	} = useSortable({
		id: props.image.id,
		transition: {
			duration: 250,
			easing: 'ease',
		},
	});

	if (isDragging && !wasDragging) setWasDragging(true);
	if (!isSorting && wasDragging) {
		setTimeout(() => setWasDragging(false), 300);
	}

	const active = isDragging || isSorting || wasDragging;

	const style = active ? {
		transform: CSS.Translate.toString(transform),
		transition: isDragging ? 'none' : transition,
		zIndex: isDragging ? 9999 : 'auto',
		position: 'relative',
	} : {};

	return (
		<CarrosselCard
			ref={setNodeRef}
			style={style}
			isDragging={isDragging}
			dragHandleProps={{ ...attributes, ...listeners }}
			{...props}
		/>
	);
};

export default SortableCarrosselCard;
